import frenchMessages from 'ra-language-french'
import { TranslationMessages } from 'react-admin'

const customFrenchMessages: TranslationMessages = {
  ...frenchMessages,
  ra: {
    ...frenchMessages.ra,
    action: {
      ...frenchMessages.ra?.action,
      clear: 'Effacer',
      reset: 'Réinitialiser',
    },
  },
  pos: {
    app_title: 'Portail Vétérinaire',
    login: {
      title: 'Connexion à adapet.ai',
      forgot_password: 'Mot de passe oublié ?',
      no_account: "Vous n'avez pas de compte ?",
      sign_up: "S'inscrire",
      or: 'ou',
      continue_microsoft: 'Continuer avec Microsoft',
    },
    shared_with_me: {
      load_failed: 'Échec du chargement des données partagées. Veuillez réessayer plus tard.',
      empty_title: 'Aucun animal partagé avec vous',
      empty_subtitle:
        "Lorsque d'autres vétérinaires partagent leurs animaux avec vous, ils apparaîtront ici.",
      shared_by: 'Partagé par %{name}',
      all_pets: 'Tous les animaux',
      specific_pets: '%{count} animal spécifique |||| %{count} animaux spécifiques',
      you_can: 'Vous pouvez : %{permissions}',
      shared_at: 'Partagé : %{date}',
      expires_at: 'Expire : %{date}',
      shared_pets_label: 'Animaux partagés :',
      view_pet: "Voir l'animal",
      pet_meta: '%{species} • Propriétaire : %{owner}',
      all_pets_message: 'Vous avez accès à tous les animaux des clients de %{name}.',
      permissions: {
        view_metrics: 'Voir les métriques',
        view_emrs: 'Voir les dossiers',
        add_activities: 'Ajouter des activités',
        add_emr_notes: 'Ajouter des notes',
      },
    },
    consent: {
      loading: 'Chargement des demandes de consentement...',
      title: "Demandes d'adhésion au groupe",
      title_with_count: "Demandes d'adhésion au groupe (%{count})",
      no_pending: "Vous n'avez aucune demande d'adhésion en attente.",
      pending_warning:
        "Vous avez des demandes d'adhésion en attente nécessitant votre consentement.",
      pending_chip: 'En attente',
      accept: 'Accepter',
      decline: 'Refuser',
      cancel: 'Annuler',
      invited_by: 'Invité par : %{name} (%{email})',
      invited_on: 'Invité le : %{date}',
      accept_dialog_title: "Accepter l'adhésion au groupe",
      decline_dialog_title: "Refuser l'adhésion au groupe",
      accept_question: 'Voulez-vous rejoindre le groupe "%{group}" ?',
      decline_question: 'Êtes-vous sûr de vouloir refuser l\'invitation à rejoindre "%{group}" ?',
      accept_warning:
        'En acceptant, vous partagerez vos données animales avec les autres membres du groupe.',
      notes_label: 'Notes (optionnel)',
      accept_notes_placeholder: "Ajouter des notes sur l'adhésion à ce groupe...",
      decline_notes_placeholder: 'Ajouter une raison pour le refus (optionnel)...',
      load_failed: 'Échec du chargement des demandes',
      update_failed: 'Échec de la mise à jour du consentement',
    },
    auth: {
      login: {
        email_not_verified:
          'Veuillez vérifier votre adresse e-mail avant de vous connecter. Consultez votre boîte de réception pour le lien de vérification.',
        invalid_credentials: 'E-mail ou mot de passe incorrect.',
        account_locked:
          'Votre compte est temporairement verrouillé en raison d’un trop grand nombre de tentatives échouées. Veuillez réessayer plus tard.',
        role_not_allowed:
          'Ce compte n’a pas accès au portail vétérinaire. Les propriétaires d’animaux doivent utiliser l’application mobile Adapet Medical.',
        generic_error: 'Échec de la connexion. Veuillez réessayer.',
        oauth_failed:
          'La connexion avec ce fournisseur a échoué. Réessayez ou utilisez votre e-mail et mot de passe.',
      },
      forgot_password: {
        title: 'Mot de passe oublié',
        description:
          'Saisissez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
        email_label: 'Adresse e-mail',
        sending: 'Envoi en cours...',
        send_button: "Envoyer l'e-mail de réinitialisation",
        back_to_login: 'Retour à la connexion',
        success: 'E-mail de réinitialisation envoyé ! Veuillez consulter votre boîte de réception.',
        email_required: "L'e-mail est requis",
        send_failed: "Échec de l'envoi de l'e-mail de réinitialisation",
        connection_error: 'Impossible de se connecter au serveur. Veuillez réessayer plus tard.',
      },
      reset_password: {
        title: 'Réinitialiser le mot de passe',
        invalid_link_title: 'Lien de réinitialisation invalide',
        invalid_link_message:
          'Ce lien de réinitialisation de mot de passe est invalide ou a expiré.',
        request_new: 'Demander un nouveau lien',
        new_password_label: 'Nouveau mot de passe',
        confirm_password_label: 'Confirmer le nouveau mot de passe',
        resetting: 'Réinitialisation...',
        reset_button: 'Réinitialiser le mot de passe',
        success: 'Mot de passe réinitialisé avec succès ! Redirection vers la connexion...',
        invalid_request: 'Demande invalide. Veuillez demander un nouveau lien.',
        reset_failed: 'Échec de la réinitialisation du mot de passe. Le lien a peut-être expiré.',
        network_error: 'Erreur réseau. Veuillez réessayer.',
        password_required: 'Le mot de passe est requis',
        passwords_dont_match: 'Les mots de passe ne correspondent pas',
      },
    },
    search: 'Rechercher',
    configuration: 'Configuration',
    language: 'Langue',
    action: {
      change_theme: 'Changer de thème',
    },
    theme: {
      name: 'Thème',
      light: 'Clair',
      dark: 'Obscur',
    },
    dashboard: {
      title: 'Tableau de bord',
      welcome_subtitle: "Bienvenue sur Adapet Medical. Voici l'actualité du jour.",
      active_patient_context: 'Contexte patient actif :',
      pet_id_label: 'ID animal : %{id}',
      no_patient_selected: 'Aucun patient sélectionné (Vue système)',
      pets_section: 'Animaux',
      devices_section: 'Appareils',
      monthly_revenue: 'CA à 30 jours',
      month_history: "Chiffre d'affaire sur 30 jours",
      new_orders: 'Nouvelles commandes',
      pending_emrs: 'Notes en attente',
      all_emrs: 'Voir toutes les notes',
      new_customers: 'Nouveaux clients',
      all_customers: 'Voir tous les clients',
      pending_orders: 'Commandes à traiter',
      current_selected_pet: 'Animal sélectionné :',
      recently_updated: 'Récemment mis à jour',
      generate_report: 'Générer un rapport',
      glucose_report: 'Rapport de glucose',
      glucose_trend: 'Tendance du glucose',
      daily_tir: 'TIR quotidien',
      daily_trends_and_activities: 'Tendances glycémiques quotidiennes et activités',
      simple_view: 'Vue simple',
      full_report: 'Rapport complet',
      print_report: 'Imprimer le rapport',
      no_data: 'N/A',
      activity_logs: "Journal d'activités",
      log_event_prompt:
        "Cliquez sur + Enregistrer un événement pour suivre les activités d'insuline, de nourriture ou d'exercice",
      date_range_navigation: 'Navigation par plage de dates',
      clinical_notes: 'Notes cliniques',
      add_note_description:
        'Ajouter une note pour cet animal qui sera incluse dans le rapport PDF.',
      portal_view: 'Vue portail',
      no_device_selected: 'Aucun appareil disponible pour cet animal',
      no_devices: 'Aucun appareil trouvé pour cet animal',
      search_pets: 'Rechercher par propriétaire, nom, ID...',
      error_loading_data: 'Erreur lors du chargement des données',
      no_data_available: 'Aucune donnée disponible',
      order: {
        items: 'par %{customer_name}, un poster |||| par %{customer_name}, %{nb_items} posters',
      },
      welcome: {
        title: 'Bienvenue sur le système de surveillance glycémique vétérinaire',
        subtitle:
          "Ceci est un système de gestion de surveillance glycémique pour animaux de compagnie. N'hésitez pas à explorer et modifier les données.",
        ra_button: 'Site web de react-admin',
        demo_button: 'Code source de cette démo',
      },
    },
    help: {
      menu_title: 'Aide et assistance',
      page_title: "Centre d'aide VetPo",
      title: 'Aide et assistance',
      welcome_message:
        "Bienvenue au centre d'aide VetPo. Trouvez des guides, des tutoriels et des ressources d'assistance pour tirer le meilleur parti de votre système de surveillance glycémique.",
      current_language: 'Langue actuelle',
      user_guides: "Guides d'utilisation",
      user_guides_desc:
        'Guides complets pour vous aider à naviguer et utiliser VetPo efficacement.',
      quick_start: 'Guide de démarrage rapide',
      quick_start_desc: 'Démarrez avec les bases du système VetPo et la navigation.',
      features_guide: 'Guide des fonctionnalités',
      features_guide_desc: 'Aperçu complet de toutes les fonctionnalités et capacités de VetPo.',
      reading_tables: 'Lecture des tableaux',
      reading_tables_desc:
        'Apprenez à interpréter les tableaux de données et les indicateurs de qualité.',
      understanding_charts: 'Comprendre les graphiques',
      understanding_charts_desc:
        "Maîtrisez les graphiques de tendance glycémique et les visualisations d'analyses.",
      faq: 'Questions fréquentes',
      faq_desc: 'Questions courantes et solutions de dépannage.',
      open_guide: 'Ouvrir le guide',
      quick_reference: 'Référence rapide',
      quick_ref: {
        navigation: 'Navigation de base',
        navigation_desc: 'Utilisez le menu latéral pour accéder aux différentes sections',
        pet_selection: "Sélection de l'animal",
        pet_selection_desc:
          'Cliquez sur les animaux dans le tableau de bord pour commencer la surveillance',
        glucose_monitoring: 'Surveillance glycémique',
        glucose_monitoring_desc:
          'Consultez les données en temps réel et les tendances dans les graphiques',
      },
      support_contact: 'Assistance et contact',
      support_desc: "Obtenez de l'aide quand vous en avez le plus besoin.",
      support: {
        email: 'Assistance par e-mail',
        email_desc: 'support@adapetmedical.com - Réponse sous 24 heures',
        chat: 'Chat en direct',
        chat_desc: 'Disponible pendant les heures ouvrables',
        phone: 'Assistance téléphonique',
        phone_desc: "1-888-444-2618 - Assistance d'urgence pour les problèmes critiques",
        chat_available:
          "Le chat en direct est disponible ! Recherchez l'icône de chat dans le coin inférieur droit de votre écran.",
      },
      contact: 'Contact',
      emergency_notice_title: "Avis d'urgence",
      emergency_notice_desc:
        "Pour les urgences vétérinaires immédiates, privilégiez toujours l'évaluation clinique directe par rapport aux données du système. VetPo fournit des outils de surveillance mais ne remplace pas le jugement vétérinaire professionnel.",
    },
    users: {
      promote_success: '%{email} promu administrateur de groupe',
      promote_confirm: "Promouvoir %{email} au rang d'administrateur de groupe (vetadmin) ?",
      promote_failed: "Échec de la promotion de l'utilisateur",
      manage_users: 'Gérer les utilisateurs',
      promote_button: 'Promouvoir administrateur de groupe',
      role_vet: 'Vétérinaire',
      role_vetadmin: 'Administrateur de groupe',
      role_admin: 'Administrateur système',
      role_siteadmin: 'Administrateur de site',
      role_cms: 'Gestionnaire de contenu',
      role_user: "Propriétaire d'animal",
      current_language: 'Langue actuelle',
      user_guides: "Guides d'utilisation",
      user_guides_desc:
        'Guides complets pour vous aider à naviguer et utiliser VetPo efficacement.',
      quick_start: 'Guide de démarrage rapide',
      quick_start_desc: 'Démarrez avec les bases du système VetPo et la navigation.',
      features_guide: 'Guide des fonctionnalités',
      features_guide_desc: 'Aperçu complet de toutes les fonctionnalités et capacités de VetPo.',
      reading_tables: 'Lecture des tableaux',
      reading_tables_desc:
        'Apprenez à interpréter les tableaux de données et les indicateurs de qualité.',
      understanding_charts: 'Comprendre les graphiques',
      understanding_charts_desc:
        "Maîtrisez les graphiques de tendance glycémique et les visualisations d'analyses.",
      faq: 'Questions fréquentes',
      faq_desc: 'Questions courantes et solutions de dépannage.',
      open_guide: 'Ouvrir le guide',
      quick_reference: 'Référence rapide',
      quick_ref: {
        navigation: 'Navigation de base',
        navigation_desc: 'Utilisez le menu latéral pour accéder aux différentes sections',
        pet_selection: "Sélection de l'animal",
        pet_selection_desc:
          'Cliquez sur les animaux dans le tableau de bord pour commencer la surveillance',
        glucose_monitoring: 'Surveillance glycémique',
        glucose_monitoring_desc:
          'Consultez les données en temps réel et les tendances dans les graphiques',
      },
      support_contact: 'Assistance et contact',
      support_desc: "Obtenez de l'aide quand vous en avez le plus besoin.",
      support: {
        email: 'Assistance par e-mail',
        email_desc: 'support@adapetmedical.com - Réponse sous 24 heures',
        chat: 'Chat en direct',
        chat_desc: 'Disponible pendant les heures ouvrables',
        phone: 'Assistance téléphonique',
        phone_desc: "1-888-444-2618 - Assistance d'urgence pour les problèmes critiques",
        chat_available:
          "Le chat en direct est disponible ! Recherchez l'icône de chat dans le coin inférieur droit de votre écran.",
      },
      contact: 'Contact',
      emergency_notice_title: "Avis d'urgence",
      emergency_notice_desc:
        "Pour les urgences vétérinaires immédiates, privilégiez toujours l'évaluation clinique directe par rapport aux données du système. VetPo fournit des outils de surveillance mais ne remplace pas le jugement vétérinaire professionnel.",
    },
    chat: {
      title: 'Assistance en direct',
      welcome_message:
        "Bonjour ! Comment puis-je vous aider aujourd'hui ? Je peux vous assister pour les questions sur les fonctionnalités de VetPo, la surveillance glycémique ou les problèmes techniques.",
      input_placeholder: 'Tapez votre message...',
      send: 'Envoyer',
      typing: "L'assistance est en train d'écrire",
      status_online: 'En ligne',
      status_offline: 'Hors ligne',
      powered_by: 'Propulsé par VetPo Assistance',
      error_general: "Désolé, j'ai rencontré une erreur. Veuillez réessayer.",
      error_network: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',
      minimize: 'Réduire',
      close: 'Fermer le chat',
      unread_indicator: 'Nouveau message',
    },
    client_profile: {
      edit_client: 'Modifier le client',
      dialog_title: 'Modifier les coordonnées du client',
      save: 'Enregistrer',
      saved: 'Coordonnées du client mises à jour.',
      save_error: 'Impossible de mettre à jour le client. Veuillez réessayer.',
      not_allowed: "Vous n'êtes pas autorisé à modifier ce client.",
      name_too_short: 'Le nom du client doit comporter au moins 2 caractères.',
      read_only_hint: 'Seule la clinique liée à ce client peut modifier ses coordonnées.',
    },
    pet_edit: {
      pet_information: "Informations sur l'animal",
      basic_details_readonly: "Informations de base de l'animal (lecture seule)",
      basic_details_editable: "Informations de base de l'animal (modifiable par le vétérinaire)",
      owner_name: 'Nom du propriétaire',
      editable_fields: 'Champs modifiables',
      vet_modifiable_fields: 'Champs modifiables par le vétérinaire',
      auto_save: {
        saving: 'Enregistrement...',
        saved: "Informations de l'animal enregistrées",
        error: "Échec de l'enregistrement des informations de l'animal",
        unsaved_changes: 'Modifications non enregistrées',
        last_saved: 'Dernier enregistrement à %{time}',
      },
    },
    alert_rules: {
      title: "Règles d'alerte de glucose",
      glucose_range: 'Plage de glucose',
      pending_sync: 'Synchronisation en attente',
      unsaved_changes: 'Modifications non enregistrées',
      configuration_desc:
        "Configurez les seuils de surveillance glycémique et les conditions d'alerte pour cet animal",
      configuration_info:
        "Définissez des seuils de glucose personnalisés pour cet animal. La plage de glucose de l'animal sera automatiquement calculée à partir des seuils d'hypoglycémie (en mmol/L). Les règles déclencheront des alertes lorsque les lectures de glucose dépasseront ces seuils.",
      add_rule_tooltip: "Ajouter une nouvelle règle d'alerte",
      save_rules: 'Enregistrer les règles',
      saving: 'Enregistrement...',
      loading: "Chargement des règles d'alerte...",
      no_rules_configured:
        'Aucune règle d\'alerte configurée. Cliquez sur "Ajouter une règle" pour créer des règles de surveillance glycémique pour cet animal.',
      rule_types: {
        critical_hypoglycemia: 'Hypoglycémie critique',
        warning_hypoglycemia: 'Alerte hypoglycémie',
        critical_hyperglycemia: 'Hyperglycémie critique',
        warning_hyperglycemia: 'Alerte hyperglycémie',
        rapid_drop: 'Chute rapide',
        dawn_pattern: "Phénomène de l'aube",
        somogyi_pattern: 'Effet Somogyi',
        postprandial_spikes: 'Pics postprandiaux',
      },
      thresholds: {
        critical_threshold: 'Seuil critique',
        warning_threshold: "Seuil d'alerte",
        hyperglycemia_threshold: "Seuil d'hyperglycémie",
        severe_hyperglycemia_threshold: "Seuil d'hyperglycémie sévère",
        somogyi_rebound_threshold: 'Seuil de rebond Somogyi',
        dawn_elevation_threshold: "Seuil d'élévation de l'aube",
        drop_threshold: 'Seuil de chute',
        analysis_window: "Fenêtre d'analyse (heures)",
        postprandial_spike_threshold: 'Seuil de pic postprandial',
        severe_spike_threshold: 'Seuil de pic sévère',
        postprandial_window_hours: 'Fenêtre post-repas (heures)',
        pre_meal_window_hours: 'Fenêtre pré-repas (heures)',
      },
      fields: {
        rule_type: 'Type de règle',
        unit: 'Unité',
        trigger_count: 'Nombre de déclenchements',
        trigger_count_helper: "Compteur d'utilisation en lecture seule",
        notes: 'Notes',
        notes_placeholder: 'Brève description ou notes sur cette règle',
        active: 'Actif',
        active_status: 'Actif',
        inactive_status: 'Inactif',
        email_notifications: 'Notifications par e-mail',
        sms_notifications: 'Notifications par SMS',
      },
      notification_settings: 'Paramètres de notification',
      delete_rule_tooltip: 'Supprimer cette règle',
      add_rule: 'Ajouter une règle',
      save: 'Enregistrer',
      auto_saving: 'Enregistrement automatique...',
      all_rule_types_added: 'Tous les types de règles ajoutés',
      help_text: {
        critical_hypoglycemia:
          'Déclenche des alertes critiques lorsque le glucose descend en dessous de ce seuil. Intervention immédiate requise.',
        warning_hypoglycemia:
          "Déclenche des alertes d'avertissement lorsque le glucose descend en dessous de ce seuil. Surveillance requise.",
        critical_hyperglycemia:
          "Déclenche des alertes critiques lorsque le glucose dépasse ce seuil. Risque d'acidocétose.",
        warning_hyperglycemia:
          "Déclenche des alertes d'avertissement lorsque le glucose dépasse ce seuil. Surveillance requise.",
        rapid_drop:
          "Déclenche des alertes lorsque le glucose chute au taux spécifié dans le temps. Utilise le seuil de chute rapide pour la détection et le seuil d'avertissement pour la surveillance de l'hypoglycémie.",
        dawn_pattern:
          "Détecte les patterns d'élévation glycémique matinale. Analyse les données sur la fenêtre temporelle spécifiée.",
        somogyi_pattern:
          "Détecte l'hyperglycémie de rebond après des épisodes d'hypoglycémie. Nécessite une fenêtre d'analyse pour la détection du pattern.",
        postprandial_spikes:
          'Détecte les pics glycémiques après les repas en comparant le glucose post-repas à la valeur de base pré-repas.',
      },
      somogyi_note:
        "Note : Le seuil d'hypoglycémie nocturne est automatiquement déterminé à partir de vos règles existantes d'hypoglycémie critique ou d'alerte. Configurez ces règles séparément pour définir le seuil bas nocturne (22h - 6h).",
      help_ranges: {
        critical_threshold: 'Plage : 1,0-4,0 mmol/L. Danger vital en dessous de 2,8 mmol/L.',
        warning_threshold: 'Plage : 3,0-5,5 mmol/L. Doit être supérieur au seuil critique.',
        hyperglycemia_threshold: 'Plage : 8,0-25,0 mmol/L. Doit être inférieur au seuil sévère.',
        severe_hyperglycemia_threshold:
          "Plage : 12,0-30,0 mmol/L. Risque d'acidocétose au-dessus de 16,0.",
        somogyi_rebound_threshold: 'Plage : 6,0-20,0 mmol/L. Niveau de glucose de rebond matinal.',
        dawn_elevation_threshold:
          'Plage : 5,0-15,0 mmol/L. Élévation naturelle du glucose matinal.',
        rapid_drop_threshold:
          "Plage : 1,0-5,0 mmol/L par 15 minutes. Taux de déclin glycémique déclenchant les alertes de chute rapide. L'algorithme analyse les 30 dernières minutes de données.",
        analysis_window: "Plage : 12-72 heures. Période d'analyse des patterns.",
        postprandial_spike_threshold:
          'Plage : 3,0-10,0 mmol/L. Seuil personnalisé de pic au-dessus de la valeur de base.',
        severe_spike_threshold: 'Plage : 5,0-15,0 mmol/L. Seuil supérieur pour les pics sévères.',
        postprandial_window_hours:
          'Plage : 2,0-6,0 heures. Fenêtre temporelle après les repas pour surveiller les pics.',
        pre_meal_window_hours:
          'Plage : 0,5-3,0 heures. Fenêtre temporelle avant les repas pour le calcul de la valeur de base.',
      },
      metadata: {
        last_triggered: 'Dernier déclenchement',
        total_triggers: 'Total des déclenchements',
      },
      notifications: {
        saved_successfully: "Règles d'alerte enregistrées avec succès",
        saved_locally: "Règles d'alerte enregistrées localement (serveur indisponible)",
        could_not_load:
          "Impossible de charger les règles d'alerte. Utilisation des valeurs par défaut.",
        glucose_range_stored:
          'Plage de glucose calculée et stockée localement (le serveur peut être indisponible)',
        glucose_range_synced: 'Plage de glucose synchronisée avec le serveur',
      },
      validation: {
        required: 'Ce champ est requis',
        out_of_range: 'La valeur doit être entre {min} et {max} {unit}',
        critical_threshold: 'Le seuil critique doit être entre 1,0 et 4,0 mmol/L (18-72 mg/dL)',
        warning_threshold: "Le seuil d'alerte doit être entre 3,0 et 5,5 mmol/L (54-99 mg/dL)",
        hyperglycemia_threshold:
          "Le seuil d'hyperglycémie doit être entre 8,0 et 25,0 mmol/L (144-450 mg/dL)",
        severe_hyperglycemia_threshold:
          "Le seuil d'hyperglycémie sévère doit être entre 12,0 et 30,0 mmol/L (216-540 mg/dL)",
        somogyi_rebound_threshold:
          'Le seuil de rebond Somogyi doit être entre 6,0 et 20,0 mmol/L (108-360 mg/dL)',
        dawn_elevation_threshold:
          "Le seuil d'élévation de l'aube doit être entre 5,0 et 15,0 mmol/L (90-270 mg/dL)",
        rapid_drop_threshold:
          'Le seuil de chute rapide doit être entre 1,0 et 5,0 mmol/L (18-90 mg/dL) par 15 minutes',
        postprandial_spike_threshold:
          'Le seuil de pic postprandial doit être entre 3,0 et 10,0 mmol/L (54-180 mg/dL)',
        severe_spike_threshold:
          'Le seuil de pic sévère doit être entre 5,0 et 15,0 mmol/L (90-270 mg/dL)',
        postprandial_window_hours: 'La fenêtre post-repas doit être entre 2,0 et 6,0 heures',
        pre_meal_window_hours: 'La fenêtre pré-repas doit être entre 0,5 et 3,0 heures',
        analysis_window: "La fenêtre d'analyse doit être entre 12 et 72 heures",
        cannot_save_with_errors:
          "Enregistrement impossible : veuillez corriger les erreurs de validation avant d'enregistrer",
      },
    },
    alerts: {
      title: 'Alertes',
      total: 'total',
      no_alerts: 'Aucune alerte ne correspond aux filtres actuels',
      alert_context: "Contexte de l'alerte",
      recommendations: 'Recommandations',
      details: 'Détails',
      acknowledge: 'Acquitter',
      acknowledged: 'Acquittée',
      active: 'Active',
      resolved: 'Résolue',
      dismissed: 'Rejetée',
      unacknowledged_count: '%{count} non acquittées',
      refresh_tooltip: 'Rafraîchir les alertes',
      monitoring_issue: 'Problème de surveillance des alertes',
      monitoring_issue_retry:
        "Les alertes peuvent ne pas s'afficher correctement. Cliquez sur rafraîchir pour réessayer.",
      no_recent_alerts: 'Aucune alerte récente',
      checking_interval: 'Vérification des alertes toutes les %{minutes} minutes',
      acknowledged_at: 'Acquittée : %{time}',
      acknowledge_success: 'Alerte acquittée avec succès',
      acknowledge_failed: "Échec de l'acquittement de l'alerte",
      acknowledge_tooltip: "Acquitter l'alerte",
      show_details: 'Afficher les détails',
      pet_alerts: "Alertes de l'animal %{petId}",
      all_pets: 'Tous les animaux',
      showing_count: 'Affichage de %{shown} sur %{total} alertes',
      critical_require_attention:
        '%{count} alerte(s) critique(s) nécessitent une attention immédiate',
      critical_alerts_count: '%{count} alerte(s) critique(s)',
      active_alerts_count: '%{count} alertes actives',
      navigate_cannot: "Navigation impossible : ID de l'animal non trouvé pour cette alerte",
      filter: {
        severity: 'Sévérité',
        type: 'Type',
        status: 'Statut',
        all: 'Tous',
        hypoglycemia: 'Hypoglycémie',
        hyperglycemia: 'Hyperglycémie',
        somogyi: 'Somogyi',
        trend: 'Tendance',
      },
      type: {
        hypoglycemia: 'Glucose bas',
        critical_hypoglycemia: 'Critique bas',
        hyperglycemia: 'Glucose élevé',
        rapid_drop: 'Chute rapide',
        pattern_detected: 'Pattern',
        somogyi: 'Effet Somogyi',
        sensor_failure: 'Problème de capteur',
        trend: 'Analyse de tendance',
        trend_analysis: 'Analyse de tendance',
        system: 'Alerte système',
      },
      severity: {
        critical: 'Critique',
        high: 'Élevée',
        medium: 'Moyenne',
        low: 'Faible',
      },
      messages: {
        critical_attention: 'alerte(s) critique(s) nécessitent une attention immédiate',
        hypoglycemia_detected:
          'Hypoglycémie détectée - niveau de glucose en dessous de la plage sûre',
        hyperglycemia_detected:
          'Hyperglycémie détectée - niveau de glucose au-dessus de la plage cible',
        somogyi_detected: "Pattern d'effet Somogyi détecté par l'analyse IA",
        trend_analysis_available: 'Nouvelle analyse de tendance glycémique disponible',
      },
      configuration: {
        title: 'Configuration des alertes',
        description: "Configurez les seuils d'alerte IA et les paramètres de détection",
        hypoglycemia_section: "Détection d'hypoglycémie",
        hyperglycemia_section: "Détection d'hyperglycémie",
        somogyi_section: "Détection de l'effet Somogyi",
        trend_analysis_section: 'Analyse de tendance IA',
        custom_rules_section: "Règles d'alerte personnalisées",
        save_config: 'Enregistrer la configuration',
        reset_config: 'Réinitialiser les valeurs par défaut',
        apply_preset: 'Appliquer un préréglage',
        presets: {
          conservative: 'Conservateur (haute sensibilité)',
          standard: 'Standard (équilibré)',
          aggressive: 'Agressif (faible sensibilité)',
        },
      },
      thresholds: {
        critical_threshold: 'Seuil critique',
        high_threshold: 'Seuil de priorité élevée',
        medium_threshold: 'Seuil de priorité moyenne',
        confidence_threshold: 'Confiance minimale',
        rebound_magnitude: 'Magnitude minimale du rebond',
      },
      notifications: {
        email_sent: 'Notification par e-mail envoyée',
        push_sent: 'Notification push envoyée',
        dashboard_updated: 'Notification du tableau de bord créée',
        vet_warning_sent: 'Avertissement vétérinaire envoyé',
        daily_report_sent: 'Rapport quotidien envoyé',
      },
      reports: {
        daily_report: "Rapport quotidien d'alertes",
        summary_title: 'Résumé des alertes',
        glucose_summary: 'Résumé glycémique',
        patterns_detected: 'Patterns détectés',
        ai_recommendations: 'Recommandations IA',
        report_period: 'Période du rapport',
        total_readings: 'Total des lectures',
        time_in_range: 'Temps dans la plage',
        episodes_count: "Nombre d'épisodes",
        generate_report: 'Générer un rapport',
        download_report: 'Télécharger le rapport',
        email_report: 'Envoyer le rapport par e-mail',
      },
    },
    menu: {
      section_patients: 'Patients',
      section_sharing: 'Collaboration',
      section_admin: 'Administration',
      clinic_teams: 'Équipe de clinique',
      all_teams_readonly: 'Toutes les équipes (lecture seule)',
      manage_users: 'Gérer les utilisateurs',
      my_account: 'Mon compte',
      pet_shares_hint:
        'Partagez des animaux spécifiques (ou tous vos animaux) avec un autre vétérinaire, et consultez les animaux partagés avec vous.',
      sales: 'Ventes',
      catalog: 'Catalogue',
      customers: 'Clients',
    },
    events: {
      review: {
        title: 'Commente sur "%{product}"',
      },
      order: {
        title: 'Commande 1 poster |||| Commande %{smart_count} posters',
      },
    },
    export: {
      button: 'Exporter',
      pdf: 'Exporter en PDF',
      image: 'Exporter en image',
    },
    glucose: {
      no_devices_found: 'Aucun appareil de surveillance glycémique trouvé pour cet animal.',
      trend_over_time: 'Tendance glycémique dans le temps',
      statistics_range: 'Statistiques glycémiques et analyse de plage',
      time_in_range_analysis: 'Analyse du temps dans la plage',
      no_data_available: 'Aucune donnée disponible',
      event_band: "Chronologie des événements d'activité",
      view_day: 'Jour',
      view_week: 'Semaine',
      view_month: 'Mois',
      reset_view: 'Réinitialiser la vue',
      reset_group: 'Réinitialiser le groupe',
      reset_selection: 'Réinitialiser la sélection',
      select_date: 'Sélectionner la date',
      start_date: 'Date de début',
      end_date: 'Date de fin',
      date_range: 'Plage de dates',
      single_date: 'Date unique',
      filter_date_range: 'Filtrer par plage de dates',
      available_range: 'Plage disponible',
      configure_target_range: 'Configurer la plage cible',
      show_activity_markers: "Afficher les marqueurs d'activité",
      hide_activity_markers: "Masquer les marqueurs d'activité",
      target_range_settings: 'Paramètres de plage cible',
      target_low: 'Cible basse',
      target_high: 'Cible haute',
      current_unit: 'Unité actuelle',
      out_of_range: 'Hors plage',
      target_range_preview: 'Aperçu',
      loading_stats: 'Chargement des statistiques...',
      error_loading_stats: 'Erreur de chargement des statistiques :',
      glucose_statistics: 'Statistiques glycémiques',
      image_export_requires:
        "La fonctionnalité d'exportation d'image nécessite la bibliothèque html2canvas",
      days: 'Jours',
      time_sensor_active: 'Durée capteur actif :',
      healthy_glucose_range: 'Plage glycémique saine :',
      below_range: 'En dessous de la plage',
      above_range: 'Au-dessus de la plage',
      average_glucose: 'Glucose moyen',
      glucose_variability: 'Variabilité glycémique (CV)',
      target_cv_message: 'CV cible ≤36% pour un contrôle glycémique optimal',
      snapshot: 'Aperçu',
      libre_view: 'LibreView',
      average_glucose_caps: 'GLUCOSE MOYEN',
      percent_above_target: '% au-dessus de la cible',
      percent_in_target: '% dans la cible',
      percent_below_target: '% en dessous de la cible',
      low_glucose_events: 'ÉVÉNEMENTS DE GLUCOSE BAS',
      average_duration: 'Durée moyenne :',
      carbs: 'Glucides',
      carbohydrate_intake: '🍎 APPORT EN GLUCIDES',
      insulin: 'INSULINE',
      rapid_acting_insulin: '💉 INSULINE À ACTION RAPIDE',
      long_acting_insulin: '💉 INSULINE À ACTION PROLONGÉE',
      total_daily_insulin: '📊 INSULINE QUOTIDIENNE TOTALE',
      comments: 'Commentaires',
      min: 'Min',
      no_significant_issues: 'Aucun problème significatif détecté durant cette période.',
      loading_chart: 'Chargement du graphique...',
      error_loading_chart: 'Erreur de chargement du graphique',
      time_in_range: 'Temps dans la plage',
      very_high: 'Très élevé (>13,9)',
      high: 'Élevé (10,1-13,9)',
      target: 'Cible (3,9-10,0)',
      low: 'Bas (3,0-3,8)',
      very_low: 'Très bas (<3,0)',
      unit: 'mmol/L',
      hour_abbr: 'h',
      minute_abbr: 'min',
      gram_abbr: 'g',
      unit_abbr: 'u',
      summary_report: 'Rapport récapitulatif',
      report_period: 'Période du rapport',
      report_generated: 'Rapport généré',
      sensor_coverage: 'Couverture du capteur',
      standard_deviation: 'Écart type (SD)',
      effective_days: 'Jours effectifs',
      data_from_continuous_monitoring:
        'Données issues de la surveillance continue à intervalles de 3 minutes',
      range_distribution: 'TIR (Temps dans la plage)',
      ideal_targets: 'Cibles idéales',
      target_range_goal: 'Temps dans la plage cible ≥70%',
      low_glucose_goal: 'Glucose bas <4%',
      variability_goal: 'Coefficient de variation <36%',
      zoom_view: 'Vue zoom',
      zoom_chart: 'Graphique zoom',
      close_zoom: 'Fermer le zoom',
      detailed_view: 'Vue détaillée',
      summary_metrics: 'Métriques récapitulatives',
      show_events: 'Afficher les événements',
      hide_events: 'Masquer les événements',
      previous_day: 'Jour précédent',
      next_day: 'Jour suivant',
      duration_in_range: 'Durée dans la plage',
      zoom_tooltip: 'Cliquer pour zoomer sur ce jour',
      before_device_start: "Avant l'activation de l'appareil",
      // Dashboard Part 2 - TIR Summary
      tir_statistics: 'Statistiques TIR',
      target_range: 'Plage cible',
      time_below_range: 'Temps sous la plage (TBR)',
      time_above_range: 'Temps au-dessus de la plage (TAR)',
      data_coverage: 'Couverture des données',
      readings: 'lectures',
      unit_mmol: 'mmol/L',
      time: 'Temps',
      glucose: 'Glucose',
      // Dashboard Part 7 - Low Glucose Events
      events: 'événements',
      showing_events_below: 'Affichage des événements en dessous de',
      no_low_events: 'Aucun événement de glucose bas détecté',
      no_low_events_description:
        'Aucune lecture en dessous de %{threshold} %{unit} durant cette période',
      // Loading/error states
      loading_snapshot: "Chargement de l'aperçu...",
      error_loading_snapshot: "Erreur de chargement de l'aperçu",
      loading_range_bar: 'Chargement de la barre de plage...',
      error_loading_range_bar: 'Erreur de chargement de la barre de plage',
      loading_daily_tir: 'Chargement du graphique TIR quotidien...',
      error_loading_daily_tir: 'Erreur de chargement du graphique TIR quotidien',
      error_loading_trend: 'Erreur de chargement du graphique',
      // Chart labels
      glucose_range_distribution: 'Distribution de la plage glycémique',
      time_format_note: 'Format horaire : HH:MM (basé sur des intervalles de lecture de 3 minutes)',
      time_in_range_percent: 'Temps dans la plage (%)',
      glucose_overline: 'Glucose',
      target_range_label: 'Plage cible',
      no_data_text: 'Aucune donnée',
      showing_devices: 'Affichage des données de %{count} appareils',
      estimated: '(Estimé)',
      y_position_estimated: '(Position Y estimée)',
      view_all: 'Tous',
      // Auto-generated comments
      auto_comment_missing_insulin:
        "%{days} jours de cette période n'ont aucun événement d'insuline enregistré.",
      auto_comment_no_carbs: "Aucune donnée d'apport en glucides disponible pour cette période.",
      auto_comment_high_low_events:
        "Nombre élevé d'événements de glucose bas (%{count}) détecté. Envisager un ajustement de l'insuline.",
      // SummaryReportSection metric card labels
      avg_glucose_short: 'Glucose moy.',
      cv_short: 'CV',
      std_dev_short: 'Écart type',
      coverage_suffix: 'couverture',
      // GlucoseLineChart
      error_loading_chart_detail: 'Erreur de chargement du graphique : %{error}',
    },
    // Dashboard Part 3 - AGP
    agp: {
      time_of_day: 'Heure de la journée',
      title: 'Profil glycémique ambulatoire',
      percentile_bands: 'Bandes de percentiles',
      median: 'Médiane (50e)',
    },
    // Dashboard Part 3 - Vet Notes
    notes: {
      vet_notes: 'Notes vétérinaires',
      add_note: 'Ajouter une note',
      save_note: 'Enregistrer la note',
      enter_note: 'Saisissez votre note clinique...',
      no_notes: 'Aucune note',
      add_first_note: 'Ajoutez la première note pour cet animal',
      total_notes: '%{count} notes',
      show_more: 'Afficher plus',
      show_less: 'Afficher moins',
      select_pet_first: 'Sélectionnez un animal pour voir les notes',
      created_successfully: 'Note créée avec succès',
      error_creating: 'Erreur lors de la création de la note',
      include_in_report: 'Inclure dans les rapports PDF',
      include_in_report_help: 'Décocher pour les notes internes uniquement',
      internal_note: 'Interne',
    },
    // Dashboard Part 6 - Activities
    activities: {
      no_activities: 'Aucune activité enregistrée',
    },
    pdf: {
      generate_report: 'Générer un rapport',
      preparing: 'Préparation...',
      capturing: 'Capture des graphiques...',
      generating: 'Génération du PDF...',
      complete: 'Terminé !',
      status_description: {
        preparing: 'Préparation des données du rapport',
        capturing: 'Capture des images de graphiques',
        generating: 'Création du document PDF',
      },
      // Part 8: Date range picker translations
      select_date_range: 'Sélectionner la plage de dates du rapport',
      quick_presets: 'Préréglages rapides',
      last_7_days: '7 derniers jours',
      last_14_days: '14 derniers jours',
      last_30_days: '30 derniers jours',
      last_90_days: '90 derniers jours',
      report_period: 'Période du rapport',
      days: 'jours',
      pet_aggregated_notice:
        'Le rapport inclura les données de tous les appareils associés à cet animal.',
      no_data_warning: 'Aucune donnée glycémique disponible pour la plage de dates sélectionnée.',
      actual_data_range: 'Données disponibles',
      use_actual_range: 'Utiliser la plage de données',
      checking_data: 'Vérification des données disponibles…',
    },
    // Veterinary CGM Report translations (6-page format)
    vet_report: {
      title: 'Rapport vétérinaire CGM Adapet',
      report_overview: 'Aperçu du rapport',
      glucose_control_summary: 'Résumé du contrôle glycémique',
      key_findings: 'Résultats clés',
      tir_statistics: 'Statistiques TIR',
      time_in_ranges: 'Temps dans les plages',
      target_range: 'Plage cible',
      time_in_range_tir: 'Temps dans la plage (TIR)',
      time_below_range_tbr: 'Temps sous la plage (TBR)',
      time_above_range_tar: 'Temps au-dessus de la plage (TAR)',
      average_glucose: 'Glucose moyen',
      data_coverage: 'Couverture des données',
      range: 'Plage',
      percent: '%',
      time: 'Temps',
      // Page 2: AGP
      agp: 'AGP',
      ambulatory_glucose_profile: 'Profil glycémique ambulatoire (AGP)',
      pattern_summary: 'Résumé des patterns',
      time_block: 'Bloc horaire',
      median: 'Médiane',
      iqr: 'IQR (25-75)',
      comment: 'Commentaire',
      // Page 3: Glucose Trend
      glucose_trend: 'Tendance glycémique',
      glucose_trend_window: 'Tendance glycémique (fenêtre du rapport)',
      target_range_band_note:
        'La plage cible est affichée sous forme de bande ombrée. Axes fixes (Y : 0-30) pour une interprétation cohérente.',
      notable_segments: 'Segments notables et annotations',
      date_time: 'Date/Heure',
      type: 'Type',
      value: 'Valeur',
      notes_column: 'Notes',
      no_notable_segments: 'Aucun segment notable détecté durant cette période.',
      // Page 4: Daily Overview
      daily_overview: 'Aperçu quotidien',
      daily_time_in_ranges: 'Temps quotidien dans les plages',
      daily_metrics: 'Métriques quotidiennes',
      date: 'Date',
      avg: 'Moy.',
      min_max: 'Min-Max',
      tir: 'TIR',
      tar: 'TAR',
      tbr: 'TBR',
      readings: 'Lectures',
      activities_column: 'Activités',
      // Page 5: Daily Trends
      daily_trends: 'Tendances quotidiennes',
      no_daily_data: 'Aucune donnée quotidienne disponible pour la période sélectionnée.',
      no_activities_recorded: 'Aucune activité enregistrée',
      // Page 6: Events & Notes
      events_and_notes: 'Événements et notes',
      low_glucose_events: 'Événements de glucose bas (en dessous du seuil)',
      events_disclaimer:
        'Les événements sont des lectures de capteur signalées en dessous du seuil configuré. Interpréter avec corrélation clinique.',
      glucose_mmol: 'Glucose (mmol/L)',
      severity: 'Sévérité',
      no_low_events: 'Aucun événement de glucose bas détecté durant cette période.',
      veterinary_assessment: 'Évaluation vétérinaire et plan',
      clinician: 'Clinicien',
      // Footer
      footer_disclaimer:
        'Généré pour examen vétérinaire. Interpréter dans le contexte clinique ; vérifier avec des tests de confirmation si nécessaire.',
      page_of: 'Page %{page} sur %{total}',
    },
    common: {
      empty_data: '—',
      add_note: 'Ajouter une note',
      not_available: 'N/A',
      clear: 'Effacer',
    },
    owners: {
      title: "Propriétaires d'animaux",
      total_count: 'Total : %{count} propriétaires',
      pets_count: 'Animaux',
      devices_count: 'Appareils',
      select_owner: 'Sélectionnez un propriétaire pour voir ses animaux et appareils',
    },
    leads: {
      title: 'Prospects Adapet 2026',
      subtitle:
        "Prospects combinés importés des pièces jointes d'e-mails VMX, WVC et Fetch Charlotte.",
      total_records: 'Total des prospects',
      unique_emails: 'E-mails uniques',
      sources: 'Sources des prospects',
      filtered_records: 'Résultats filtrés',
      search_placeholder: 'Rechercher par prospect, entreprise, e-mail, rôle ou source',
      all_events: 'Tous les événements',
      empty_state: 'Aucun prospect ne correspond aux filtres actuels.',
      access_denied:
        'Seuls les administrateurs de site peuvent consulter les prospects marketing importés.',
    },
    shares: {
      share_created_successfully: 'Partage créé avec succès',
      share_revoked_successfully: 'Partage révoqué avec succès',
      share_creation_failed: 'Certains partages ont échoué. Veuillez réessayer.',
    },
    profile: {
      title: 'Profil',
      profile_with_info: 'Profil : %{name} (ID : %{id})',
      my_profile: 'Mon profil',
      edit_profile: 'Modifier le profil',
      name: 'Nom',
      id: 'ID',
      email: 'E-mail',
      phone: 'Téléphone',
      clinic: 'Clinique',
      field_clinic_name: 'Nom de la clinique',
      field_address: 'Adresse',
      field_postal_code: 'Code postal',
      field_city: 'Ville',
      field_state: 'État / Province',
      field_country: 'Pays',
      country_us: 'États-Unis',
      country_ca: 'Canada',
      validation_state_invalid: 'Veuillez sélectionner un État ou une province valide',
      field_short_description: 'Description courte',
      field_full_profile: 'Profil complet',
      placeholder_short_description: 'Brève description des services de votre clinique',
      placeholder_full_profile:
        'Description détaillée de votre cabinet vétérinaire, de vos services et de votre expertise',
      not_set: 'Non défini',
      qr_code: 'Code QR',
      glucose_unit: 'Unité de glucose',
      glucose_unit_mmol: 'mmol/L',
      glucose_unit_mgdl: 'mg/dL',
      validation_name_required: 'Le nom est requis',
      validation_phone_invalid: 'Veuillez fournir un numéro de téléphone valide (10 à 15 chiffres)',
      validation_postal_invalid: 'Veuillez fournir un code postal valide',
      profile_updated: 'Profil mis à jour avec succès',
      profile_update_failed: 'Échec de la mise à jour du profil',
      glucose_unit_saved: "La préférence d'unité de glucose a été enregistrée",
      glucose_unit_save_failed: "Échec de l'enregistrement de la préférence d'unité de glucose",
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      print: 'Imprimer',
      ok: 'OK',
    },
    reports: {
      export_csv: 'Exporter CSV',
      daily_glucose_range: 'Plage de glucose quotidienne',
      daily_glucose_lines: 'Lignes de glucose quotidiennes',
      daily_glucose_histograms: 'Histogrammes de glucose quotidiens',
      combined_glucose_histogram: 'Histogramme de glucose combiné',
      axis_labels: {
        glucose: 'Glucose',
        date: 'Date',
        time_of_day: 'Heure de la journée',
        count: 'Nombre',
      },
      chart_series: {
        daily_glucose: 'Glucose quotidien',
        daily_avg: 'Moyenne quotidienne',
      },
      hover_labels: {
        min: 'Min',
        max: 'Max',
        avg: 'Moy',
      },
    },
    metrics: {
      filters: {
        device: 'Appareil',
        timestamp_gte: 'Date ≥',
        timestamp_lte: 'Date ≤',
        glucose_gte: 'Glucose ≥',
        glucose_lte: 'Glucose ≤',
      },
    },
  },
  resources: {
    customers: {
      name: 'Client |||| Clients',
      fields: {
        address: 'Rue',
        birthday: 'Anniversaire',
        city: 'Ville',
        stateAbbr: 'État',
        orders: 'Commandes',
        first_name: 'Prénom',
        first_seen: 'Première visite',
        full_name: 'Nom',
        groups: 'Segments',
        has_newsletter: 'Abonné à la newsletter',
        has_ordered: 'A commandé',
        last_name: 'Nom',
        last_seen: 'Vu le',
        last_seen_gte: 'Vu depuis',
        latest_purchase: 'Dernier achat',
        name: 'Nom',
        total_spent: 'Dépenses',
        zipcode: 'Code postal',
        password: 'Mot de passe',
        confirm_password: 'Confirmez le mot de passe',
      },
      filters: {
        last_visited: 'Dernière visite',
        today: "Aujourd'hui",
        this_week: 'Cette semaine',
        last_week: 'La semaine dernière',
        this_month: 'Ce mois-ci',
        last_month: 'Le mois dernier',
        earlier: 'Plus tôt',
        has_ordered: 'A déjà commandé',
        has_newsletter: 'Abonné newsletter',
        group: 'Segment',
      },
      fieldGroups: {
        identity: 'Identité',
        address: 'Adresse',
        stats: 'Statistiques',
        history: 'Historique',
        password: 'Mot de passe',
        change_password: 'Changer le mot de passe',
      },
      page: {
        delete: 'Supprimer le client',
      },
      errors: {
        password_mismatch: 'La confirmation du mot de passe est différente du mot de passe.',
      },
      notifications: {
        created: 'Client créé |||| %{smart_count} clients créés',
        updated: 'Client mis à jour |||| %{smart_count} clients mis à jour',
        deleted: 'Client supprimé |||| %{smart_count} clients supprimés',
      },
    },
    groups: {
      name: 'Groupe |||| Groupes',
      fields: {
        name_helper: 'Choisissez un nom unique pour votre groupe vétérinaire',
        description_helper: 'Décrivez la finalité de ce groupe (facultatif)',
      },
      notifications: {
        created: 'Groupe créé avec succès',
        updated: 'Groupe mis à jour avec succès',
      },
      errors: {
        forbidden: "Vous n'avez pas la permission d'effectuer cette action",
        create_failed: 'Échec de la création du groupe. Veuillez réessayer.',
        no_create_permission:
          "Vous n'avez pas la permission de créer des groupes. Seuls les administrateurs vétérinaires peuvent créer des groupes.",
      },
    },
    orders: {
      name: 'Commande |||| Commandes',
      amount: '1 commande |||| %{smart_count} commandes',
      title: 'Commande n°%{reference}',
      fields: {
        basket: {
          delivery: 'Frais de livraison',
          reference: 'Référence',
          quantity: 'Quantité',
          sum: 'Sous-total',
          tax_rate: 'TVA',
          taxes: 'TVA',
          total: 'Total',
          unit_price: 'P.U.',
        },
        address: 'Adresse',
        customer_id: 'Client',
        date_gte: 'Émises depuis',
        date_lte: 'Émises avant',
        nb_items: 'Nb articles',
        reference: 'Référence',
        returned: 'Annulée',
        status: 'État',
        total_gte: 'Montant minimum',
      },
      section: {
        order: 'Commande',
        customer: 'Client',
        shipping_address: 'Adresse de livraison',
        items: 'Articles',
        total: 'Total',
      },
      notifications: {
        created: 'Commande créée |||| %{smart_count} commandes créées',
        updated: 'Commande mise à jour |||| %{smart_count} commandes mises à jour',
        deleted: 'Commande supprimée |||| %{smart_count} commandes supprimées',
      },
    },
    invoices: {
      name: 'Facture |||| Factures',
      fields: {
        id: 'Numéro',
        date: 'Date de facture',
        customer_id: 'Client',
        order_id: 'Commande',
        date_gte: 'Émises depuis',
        date_lte: 'Émises avant',
        address: 'Adresse',
        total_ex_taxes: 'Montant HT',
        delivery_fees: 'Frais de livraison',
        taxes: 'TVA',
        total_gte: 'Montant minimum',
      },
      notifications: {
        created: 'Facture créée |||| %{smart_count} factures créées',
        updated: 'Facture mise à jour |||| %{smart_count} factures mises à jour',
        deleted: 'Facture supprimée |||| %{smart_count} factures supprimées',
      },
    },
    products: {
      name: 'Poster |||| Posters',
      fields: {
        category_id: 'Catégorie',
        height_gte: 'Hauteur mini',
        height_lte: 'Hauteur maxi',
        height: 'Hauteur',
        image: 'Photo',
        price: 'Prix',
        reference: 'Référence',
        sales: 'Ventes',
        stock_lte: 'Stock faible',
        stock: 'Stock',
        thumbnail: 'Aperçu',
        width_gte: 'Largeur mini',
        width_lte: 'Largeur maxi',
        width: 'Largeur',
      },
      tabs: {
        image: 'Image',
        details: 'Détails',
        description: 'Description',
        emrs: 'Notes',
      },
      filters: {
        categories: 'Catégories',
        stock: 'Stock',
        no_stock: 'En rupture',
        low_stock: '1 - 9 unités',
        average_stock: '10 - 49 unités',
        enough_stock: '50 unités et plus',
        sales: 'Ventes',
        best_sellers: 'Meilleures ventes',
        average_sellers: 'Moyennes',
        low_sellers: 'Peu vendu',
        never_sold: 'Jamais vendu',
      },
      notifications: {
        created: 'Poster créé |||| %{smart_count} posters créés',
        updated: 'Poster mis à jour |||| %{smart_count} posters mis à jour',
        deleted: 'Poster supprimé |||| %{smart_count} posters supprimés',
      },
    },
    categories: {
      name: 'Catégorie |||| Catégories',
      fields: {
        name: 'Nom',
        products: 'Produits',
      },
      notifications: {
        created: 'Catégorie créée |||| %{smart_count} catégories créées',
        updated: 'Catégorie mise à jour |||| %{smart_count} catégories mises à jour',
        deleted: 'Catégorie supprimée |||| %{smart_count} catégories supprimées',
      },
    },
    owners: {
      name: 'Propriétaire |||| Propriétaires',
      amount: '1 propriétaire |||| %{smart_count} propriétaires',
    },
    leads: {
      name: 'Prospect |||| Prospects',
      amount: '1 prospect |||| %{smart_count} prospects',
      fields: {
        event: 'Événement',
        name: 'Prospect',
        email: 'E-mail',
        company: 'Entreprise',
        role: 'Rôle',
        location: 'Localisation',
        context: 'Contexte',
        captured_at: 'Capturé le',
      },
    },
    pets: {
      name: 'Animal |||| Animaux',
      amount: '1 animal |||| %{smart_count} animaux',
      detail: "Détail de l'animal",
      search_placeholder: "Rechercher par nom d'animal / propriétaire / race / espèce / ID",
      fields: {
        id: 'Id',
        name: "Nom de l'animal",
        owner: 'Propriétaire',
        pet_name: "Nom de l'animal",
        dob: 'Date de naissance',
        birthday: 'Anniversaire',
        created: 'Créé',
        owner_email: 'E-mail du propriétaire',
        owner_website: 'Site web du propriétaire',
        species: 'Espèce',
        breed: 'Race',
        height: 'Taille',
        weight: 'Poids',
        sex: 'Sexe',
        color: 'Couleur',
        createdAt: 'Créé',
        updatedAt: 'Mis à jour',
        sensor_activated: 'Capteur activé',
        vet_account: 'Compte vétérinaire',
        vet_account_not_bound: 'Non lié à un compte vétérinaire',
      },
      sex_options: {
        male: 'Mâle',
        female: 'Femelle',
        neutered_male: 'Mâle castré',
        spayed_female: 'Femelle stérilisée',
        unknown: 'Inconnu',
      },
      action: {
        accept: 'Accepter',
        reject: 'Rejeter',
      },
    },
    activities: {
      name: 'Activité |||| Activités',
      amount: '1 activité |||| %{smart_count} activités',
      detail: "Détail de l'activité",
      fields: {
        id: 'Id',
        name: 'Nom',
        owner: 'Propriétaire',
        pet: 'Animal',
        pet_id: 'ID animal',
        type: 'Type',
        start_time: 'Heure de début',
        end_time: 'Heure de fin',
        time: 'Durée',
        duration: 'Durée',
        description: 'Description',
        created_at: 'Créé le',
        updated_at: 'Mis à jour le',
      },
      insulin: {
        brand: 'Marque',
        custom_brand: 'Marque personnalisée',
        dosage: 'Dosage',
        units: 'unités',
      },
      action: {
        accept: 'Accepter',
        reject: 'Rejeter',
      },
    },
    devices: {
      name: 'Appareil |||| Appareils',
      amount: '1 appareil |||| %{smart_count} appareils',
      detail: "Détail de l'appareil",
      fields: {
        id: 'Id',
        name: 'Nom',
        owner: 'Propriétaire',
        pet: 'Animal',
        type: 'Type',
        start_time: 'Heure de début',
        glucose_trend: 'Tendance glycémique',
        timezone: 'Fuseau horaire',
        createdAt: 'Créé',
        updatedAt: 'Mis à jour',
      },
      action: {
        accept: 'Accepter',
        reject: 'Rejeter',
      },
    },
    metrics: {
      name: 'Lecture |||| Lectures',
      amount: '1 lecture |||| %{smart_count} lectures',
      detail: 'Détail de la lecture',
      fields: {
        id: 'Id',
        name: 'Nom',
        owner: 'Propriétaire',
        device: 'Appareil',
        offset: 'Décalage',
        timestamp: 'Horodatage',
        glucose: 'Glucose',
        createdAt: 'Créé le',
        updatedAt: 'Mis à jour le',
      },
      action: {
        accept: 'Accepter',
        reject: 'Rejeter',
      },
    },
    emrs: {
      name: 'Note |||| Notes',
      amount: '1 note |||| %{smart_count} notes',
      detail: 'Détail de la note',
      fields: {
        id: 'Id',
        pet: 'Animal',
        pet_id: 'ID animal',
        vet: 'Vétérinaire',
        notes: 'Notes',
        number: '#',
        author: 'Auteur',
        content: 'Contenu',
        timestamp: 'Date',
        date: 'Date',
        created: 'Créé',
        updated: 'Mis à jour',
        createdAt: 'Créé',
        updatedAt: 'Mis à jour',
      },
      action: {
        accept: 'Accepter',
        reject: 'Rejeter',
        add_note: 'Ajouter une note',
      },
      notifications: {
        created: 'Note créée |||| %{smart_count} notes créées',
        updated: 'Note mise à jour |||| %{smart_count} notes mises à jour',
        deleted: 'Note supprimée |||| %{smart_count} notes supprimées',
        approved_success: 'Note approuvée',
        approved_error: 'Erreur : note non approuvée',
        rejected_success: 'Note rejetée',
        rejected_error: 'Erreur : note non rejetée',
      },
    },
    glucose: {
      axis_labels: {
        max: 'Max',
        min: 'Min',
        glucose: 'Glucose',
        date: 'Date',
        time: 'Temps',
      },
      hover_labels: {
        max: 'Max',
        min: 'Min',
      },
    },
    segments: {
      name: 'Segment |||| Segments',
      fields: {
        customers: 'Clients',
        name: 'Nom',
      },
      data: {
        compulsive: 'Compulsif',
        collector: 'Collectionneur',
        ordered_once: 'A commandé',
        regular: 'Régulier',
        returns: 'A renvoyé',
        reviewer: 'Commentateur',
      },
    },
  },
}

export default customFrenchMessages
